import { render } from "./HrHelp.vue?vue&type=template&id=78e93dd9"
import script from "./HrHelp.vue?vue&type=script&lang=js"
export * from "./HrHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__